import { Link } from 'react-router-dom';
import { LuChevronRight } from 'react-icons/lu';
import Particles from './Particles';

/**
 * Shared page hero for inner pages.
 * Props: tag, title, subtitle, breadcrumb [{ label, to }], children (right column), bgColor
 */
function PageHero({ tag, title, subtitle, breadcrumb = [], children, bgColor }) {
  return (
    <section
      className="page-hero"
      style={{
        background: bgColor ||
          `radial-gradient(ellipse 70% 55% at 65% 35%, rgba(124,58,237,.08) 0%, transparent 65%),
           radial-gradient(ellipse 50% 45% at 20% 80%, rgba(8,145,178,.06) 0%, transparent 55%),
           var(--bg)`,
      }}
      aria-label={`${tag || 'Page'} hero`}
    >
      <Particles count={10} />

      <div className="container" style={{ position: 'relative', zIndex: 2, width: '100%' }}>
        <div className="page-hero-content">

          {/* Breadcrumb */}
          {breadcrumb.length > 0 && (
            <nav className="page-hero-breadcrumb" aria-label="Breadcrumb">
              <Link to="/">Home</Link>
              {breadcrumb.map((b, i) => (
                <span key={i} style={{ display: 'flex', alignItems: 'center', gap: 6 }}>
                  <LuChevronRight size={12} className="sep" />
                  {b.to
                    ? <Link to={b.to}>{b.label}</Link>
                    : <span className="current">{b.label}</span>
                  }
                </span>
              ))}
            </nav>
          )}

          {/* Grid: text left | visual right */}
          <div className={`page-hero-grid${children ? ' page-hero-grid--two-col' : ''}`}>
            {/* Text column */}
            <div className="page-hero-text-col">
              {tag && <div className="section-tag">{tag}</div>}
              <h1 className="page-title" style={{ marginBottom: 16 }}>{title}</h1>
              {subtitle && (
                <p className="section-sub" style={{ maxWidth: 540 }}>{subtitle}</p>
              )}
            </div>

            {/* Visual column */}
            {children && (
              <div className="page-hero-visual">
                {children}
              </div>
            )}
          </div>
        </div>
      </div>
    </section>
  );
}

export default PageHero;
